import React from 'react'

let CardBody = ({children}) => <div className='card-body'>{children}</div>

export default CardBody